import { UserInfoFI } from "@/components/HolderForm/UserInfoFI.ts";
import { UserInfoFormValues } from "@/components/HolderForm/UserInfoFormValues.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

export const useHolderInfoForm = () => {
  const reservationHolderData = useEngineStore((s) => s.reservationHolderData);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    watch,
    trigger,
    reset,
    getValues,
  } = useForm<UserInfoFormValues>({ mode: "onChange", defaultValues: reservationHolderData ?? undefined });

  const watchFirstName = watch([UserInfoFI.FirstName])[0];
  const watchLastName = watch([UserInfoFI.LastName])[0];

  useEffect(() => {
    if (reservationHolderData) {
      reset(reservationHolderData);
    }
  }, [reservationHolderData, reset]);

  return {
    holderFormData: {
      register,
      handleSubmit,
      errors,
      isValid,
      setValue,
      watch,
      trigger,
      reset,
      getValues,
    },
    watchFirstName,
    watchLastName,
  };
};
